module.exports = __webpack_public_path__ + "img/icon1.5d4d1681.jpg";